import henaoPic from "@/public/images/artists/henao.png";
import { Artist } from "@/types/types";

export const henao = {
  id: "25",
  name: "Henao",
  image: henaoPic,
  description: `Meet "Henao," the indie pop sensation. With a voice that's both hauntingly soulful and fiercely independent, Henao breathes new life into every song. Her evocative vocals seamlessly blend vulnerability and strength, telling stories that resonate deeply.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fhenao-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Indie", "RnB"],
      secondary: ["Singer", "Soulful"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 52,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
